import EvaluationThumbsSubtypeDetails from "../details/EvaluationThumbsSubtypeDetails";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { EvaluationThumbsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationThumbsSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: EvaluationThumbsSubtypeDataModel;
}

export default function EvaluationThumbsSubtypeSummary(props: Props) {
    return <EvaluationThumbsSubtypeDetails {...props} />
}
